/**
 * Created by linuxr on 2019/10/16.
 */
import * as esriLoader from 'esri-loader'

export default {
  name: 'ArcgisMap',
  data() {
    return {
      view: null,
      map: null,
      distanceMeasurementVisible: false, // 距离测量是否可见
      overviewVisible: false, // 缩略图是否可见
      scaleBarVisible: false, // 比例尺是否可见
      coordinateConversionVisible: false, // 取坐标是否可见
      // 多选
      startSelectionMapPoint: null, // 开始选择地图点
      stopSelectionMapPoint: null, // 停止选择地图点
      startSelectionScreenPoint: null, // 开始选择屏幕点
      stopSelectionScreenPoint: null, // 停止选择屏幕点
      esriOptions: {
        url: '/static/arcgis_js_api/library/4.10/init.js'
      },
      classificationMethod: '1', // 标注方式
      selectionType: '1', // 选择类型
      geographicExtent: {} // 显示范围
    }
  },
  props: {
    url: {
      type: String,
      default() {
        return 'http://cache1.arcgisonline.cn/arcgis/rest/services/ChinaOnlineStreetGray/MapServer'
      }
    },
    zoom: {
      type: Number,
      default() {
        return 10
      }
    },
    center: {
      type: Array,
      default() {
        return [114.79614, 30.84358]
      }
    },
    mapLoad: {
      type: Function
    },
    mapUnLoad: {
      type: Function
    },
    extentChange: {
      type: Function
    },
    boxSelectStart: {
      type: Function
    },
    boxSelectComplete: {
      type: Function
    }
  },
  computed: {
    getGeographicExtent: function() {
      return this.geographicExtent
    }
  },
  watch: {
    zoom: {
      immediate: true, // 很重要！！！
      handler(val) {
        if (val) {
          if (this.view && this.view.zoom !== val) {
            this.view.zoom = val
            console.log('>>> 地图层级(' + this.view.zoom + ')已更新')
          }
        }
      }
    },
    center: {
      immediate: true, // 很重要！！！
      handler(val) {
        if (val) {
          if (this.view && this.view.center !== val) {
            this.view.center = val
            console.log('>>> 中心点[' + this.view.center.longitude + ',' + this.view.center.latitude + ']已更新')
          }
        }
      }
    }
  },
  mounted() {
    // 加载arcgis
    esriLoader.loadCss(
      '/static/arcgis_js_api/library/4.10/esri/themes/light/main.css'
    )
    esriLoader
      .loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/widgets/Compass',
          'esri/widgets/ScaleBar',
          'esri/widgets/CoordinateConversion',
          'esri/layers/TileLayer',
          'esri/core/watchUtils',
          'esri/views/2d/draw/Draw'
        ],
        this.esriOptions
      )
      .then(
        ([
          Map,
          MapView,
          Compass,
          ScaleBar,
          CoordinateConversion,
          TileLayer,
          watchUtils,
          Draw]) => {
          console.log('>>> 开始加载地图')
          this.initMap([Map, MapView, TileLayer])
          this.initMapWidgets([Compass, ScaleBar, CoordinateConversion])
          if (this.overviewVisible) {
            this.initOverviewMap([Map, MapView, TileLayer, watchUtils])
          }
          // 初始化绘图器
          this.draw = new Draw({
            view: this.view
          })
        }
      )
      .catch(err => {
        console.log('err:  ', err)
      })
  },
  beforeDestroy() {
    // 触发地图将卸载事件
    if (this.mapUnload) {
      this.mapUnload()
    }

    //
    if (this.draw) {
      this.stopMultiSelection()
      this.draw = null
    }

    // 销毁地图
    if (this.view) {
      this.view.container = null
    }

    if (this.ccWidget) {
      this.ccWidget.destroy()
      this.ccWidget = null
    }

    if (this.distanceWidget) {
      this.distanceWidget.destroy()
      this.distanceWidget = null
    }

    if (this.areaWidget) {
      this.areaWidget.destroy()
      this.areaWidget = null
    }
  },
  methods: {
    // 加载地图
    initMap([Map, MapView, TileLayer]) {
      let layer = new TileLayer({
        url: this.url
      })
      this.map = new Map({
        layers: [layer]
      })
      // let map = new Map({ basemap: 'streets' })
      this.view = new MapView({
        container: 'map',
        map: this.map,
        zoom: this.zoom,
        center: this.center
      })

      var _this = this
      this.view.when(function() {
        // All the resources in the MapView and the map have loaded. Now execute additional processes
        console.log('>>> 加载地图已完成')
        // 触发地图已加载事件
        if (_this.mapLoad) {
          _this.mapLoad()
        }
      }, function(err) {
        console.log('err:  ', err)
      })

      this.view.watch('extent', function(evt) { // 范围变化，缩放和拖动都会触发该事件
        // console.log('>>> 地图范围发生变化')
        esriLoader
          .loadModules(
            ['esri/geometry/support/webMercatorUtils'],
            this.esriOptions
          )
          .then(([webMercatorUtils]) => {
            // 更新范围（将web墨卡托(3857)转经纬度坐标(4326)）
            if (_this.view.spatialReference.isWebMercator) {
              let geographicMapValues = webMercatorUtils.xyToLngLat(_this.view.extent.xmin, _this.view.extent.ymin)
              _this.geographicExtent.xmin = geographicMapValues[0]
              _this.geographicExtent.ymin = geographicMapValues[1]
              geographicMapValues = webMercatorUtils.xyToLngLat(_this.view.extent.xmax, _this.view.extent.ymax)
              _this.geographicExtent.xmax = geographicMapValues[0]
              _this.geographicExtent.ymax = geographicMapValues[1]
            } else {
              _this.geographicExtent.xmin = _this.view.extent.xmin
              _this.geographicExtent.ymin = _this.view.extent.ymin
              _this.geographicExtent.xmax = _this.view.extent.xmax
              _this.geographicExtent.ymax = _this.view.extent.ymax
            }
            _this.geographicExtent.spatialReference = _this.view.spatialReference
            // 更新缩放层级
            _this.$emit('update:zoom', _this.view.zoom)
            console.log(_this.view.zoom, _this.geographicExtent.xmin, _this.geographicExtent.ymin)
            // 触发范围改变事件
            if (_this.extentChange) {
              _this.extentChange()
            }
          })
          .catch(err => {
            console.log('err: >>> ', err)
          })
      })
    },
    // 初始化地图窗口
    initMapWidgets([Compass, ScaleBar, CoordinateConversion]) {
      // 方向罗盘
      this.compass = new Compass({
        view: this.view
      })
      this.view.ui.add(this.compass, 'top-left')

      // 比例尺
      this.scaleBar = new ScaleBar({
        unit: 'dual',
        view: this.view
      })
      // this.view.ui.add(this.scaleBar, 'bottom-left')

      // 坐标转换窗口
      this.ccWidget = new CoordinateConversion({
        mode: 'capture',
        multipleConversions: false,
        currentLocation: this.center,
        view: this.view
      })
      this.ccWidget.formats = this.ccWidget.formats.filter(f => {
        return f.name === 'xy' || f.name === 'basemap'
      })
      // this.view.ui.add(this.ccWidget, 'top-right')

      // 工具栏
      this.view.ui.add('tool-bar', 'top-right')
    },
    // 初始化缩略图
    initOverviewMap([Map, MapView, TileLayer, watchUtils]) {
      // overview map
      let layer = new TileLayer({
        url: this.url
      })
      let oMap = new Map({
        layers: [layer]
      })
      this.oView = new MapView({
        container: 'overview-map',
        map: oMap,
        zoom: this.zoom,
        center: this.center
      })
      // 不显示其他组件
      this.oView.ui.components = []

      // 缩略地图和地图同步
      watchUtils.whenTrue(this.view, 'stationary', () => {
        if (this.view && this.view.center) { // 同步中心点
          this.oView.center = this.view.center
        }
        if (this.view && this.view.zoom) { // 同步缩放
          this.oView.zoom = this.view.zoom
        }
      })
    },
    // 设置工具栏活动按钮
    setToolBarActiveButton(val) {
      this.view.focus()
      let elements = document.getElementsByClassName('active')
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove('active')
      }
      if (val) {
        val.classList.add('active')
      }
    },
    // 显示/隐藏缩略图
    toggleOverviewMap() {
      this.overviewVisible = !this.overviewVisible

      if (this.overviewVisible && !this.oView) {
        esriLoader
          .loadModules(
            ['esri/Map', 'esri/views/MapView', 'esri/layers/TileLayer', 'esri/core/watchUtils'],
            this.esriOptions
          )
          .then(([Map, MapView, TileLayer, watchUtils]) => {
            this.initOverviewMap([Map, MapView, TileLayer, watchUtils])
          })
          .catch(err => {
            console.log('err: >>> ', err)
          })
      }
    },
    // 比例尺
    toggleScaleBar() {
      this.scaleBarVisible = !this.scaleBarVisible
      if (this.scaleBarVisible) {
        return this.view.ui.add(this.scaleBar, 'bottom-left')
      }
      return this.view.ui.remove(this.scaleBar)
    },
    toggleDistanceMeasure() {
      if (this.distanceWidget) {
        this.distanceWidget.destroy()
        this.distanceWidget = null
        this.view.ui.remove(this.distanceWidget)
      }
      this.distanceMeasurementVisible = !this.distanceMeasurementVisible
      if (this.distanceMeasurementVisible) {
        this.distanceMeasure()
      }
    },
    // 距离测量
    distanceMeasure() {
      console.log('>>> 距离测量...')
      this.setToolBarActiveButton(null)
      if (this.areaWidget) {
        this.areaWidget.destroy()
        this.areaWidget = null
        this.view.ui.remove(this.areaWidget)
      }
      if (this.distanceWidget) {
        this.distanceWidget.destroy()
        this.distanceWidget = null
        this.view.ui.remove(this.distanceWidget)
        return
      }

      // create new distance measurement
      esriLoader
        .loadModules(['esri/widgets/DistanceMeasurement2D'], this.esriOptions)
        .then(([DistanceMeasurement2D]) => {
          this.distanceWidget = new DistanceMeasurement2D({
            view: this.view
          })
          this.view.ui.add(this.distanceWidget, 'top-right')
          this.setToolBarActiveButton(document.getElementById('distanceBtn'))
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    // 面积测量
    areaMeasure() {
      console.log('>>> 面积测量...')
      this.setToolBarActiveButton(null)
      if (this.distanceWidget) {
        this.distanceWidget.destroy()
        this.distanceWidget = null
        this.view.ui.remove(this.distanceWidget)
      }
      if (this.areaWidget) {
        this.areaWidget.destroy()
        this.areaWidget = null
        this.view.ui.remove(this.areaWidget)
        return
      }

      // create new area measurement
      esriLoader
        .loadModules(['esri/widgets/AreaMeasurement2D'], this.esriOptions)
        .then(([AreaMeasurement2D]) => {
          this.areaWidget = new AreaMeasurement2D({
            view: this.view
          })
          this.view.ui.add(this.areaWidget, 'top-right')
          this.setToolBarActiveButton(document.getElementById('areaBtn'))
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    // 添加图像图形
    addImageGraphic(id, kind, data) {
      esriLoader
        .loadModules(
          [
            'esri/Graphic'
          ],
          this.esriOptions
        )
        .then(
          ([
            Graphic
          ]) => {
            let imageSymbol = { // 外观
              type: 'picture-marker',
              url: this.getMarkerIcon(data),
              width: '32px',
              height: '32px'
            }

            let point = { // 坐标
              type: 'point', // autocasts as new Point()
              longitude: data.longitude,
              latitude: data.latitude
            }

            let imageGraphic = new Graphic({
              geometry: point,
              symbol: imageSymbol,
              attributes: {id: id, kind: kind, data: data}
            })
            this.view.graphics.add(imageGraphic)

            // let textSymbol = {
            //   type: 'text', // autocasts as new TextSymbol()
            //   color: 'black',
            //   haloColor: 'black',
            //   haloSize: '1px',
            //   text: 'aaaaaaaaaaaaaaa', // data.name,
            //   xoffset: 3,
            //   yoffset: 3,
            //   font: { // autocasts as new Font()
            //     size: 12,
            //     family: 'Courier',
            //     weight: 'bold'
            //   }
            // }
            // let textGraphic = new Graphic(point, textSymbol)
            // this.graphicLayer.add(textGraphic)
          }
        )
        .catch(err => {
          console.log('err: >>>>>> ', err)
        })
    },
    // 添加矩形图形
    addRectanleGraphic(id, kind, rectangle, Graphic) {
      let graphic = new Graphic({
        geometry: rectangle,
        symbol: {
          type: 'simple-fill', //
          color: [230, 230, 255, 0.3],
          style: 'solid',
          outline: {
            color: '#9acd32', // '#FDDF42',
            width: 1
          }
        },
        attributes: { id: id, kind: kind, data: null }
      })
      this.view.graphics.add(graphic)
    },
    // 定位图像图形
    locateImageGraphic(id, kind) {
      if (this.view && this.view.graphics) {
        let findIndex = this.view.graphics.findIndex(item => {
          return item.attributes['id'] === id && item.attributes['kind'] === kind
        })

        if (findIndex >= 0) {
          let graphic = this.view.graphics.items[findIndex]
          // 将定位标记作为中心点
          this.view.center = [graphic.attributes['data'].longitude, graphic.attributes['data'].latitude]
          // 闪烁3次
          var blinkTimes = 0
          var timer = setInterval(() => {
            ++blinkTimes
            if (blinkTimes > 6) {
              clearInterval(timer)
              return
            }
            graphic.visible = !graphic.visible
          }, 500)
        }
      }
    },
    // 移除图形
    removeGraphic(id, kind) {
      if (this.view && this.view.graphics) {
        let findIndex = this.view.graphics.findIndex(item => {
          return item.attributes['id'] === id && item.attributes['kind'] === kind
        })

        if (findIndex >= 0) this.view.graphics.removeAt(findIndex)
      }
    },
    // 添加图形单击事件处理器
    addGraphicClickEventHandler(callback) {
      this.view.on('click', event => {
        // Search for symbols on click's position
        this.view.hitTest(event.screenPoint).then(function(response) {
          // Retrieve the first symbol
          var graphic = response.results[0].graphic
          if (graphic) {
            callback(graphic)
          }
        })
      })
    },
    // 开始多选
    startMultiSelection() {
      esriLoader
        .loadModules(
          [
            'esri/Graphic',
            'esri/geometry/Polygon',
            'esri/geometry/Point',
            'esri/geometry/ScreenPoint'
          ],
          this.esriOptions
        )
        .then(
          ([
            Graphic,
            Polygon,
            Point,
            ScreenPoint
          ]) => {
            // 框选开始
            if (this.boxSelectStart) {
              this.boxSelectStart()
            }

            // start new draw
            this.stopMultiSelection()

            //
            let action = this.draw.create('rectangle')
            action.on('vertex-add', evt => // 开始绘制事件处理
              this.showRectangleGraphic(evt, Point, ScreenPoint, Graphic, Polygon))
            action.on('cursor-update', evt => // 鼠标移动事件处理
              this.showRectangleGraphic(evt, Point, ScreenPoint, Graphic, Polygon))
            action.on('draw-complete', evt => { // 绘制完成事件处理
              let vertices = evt.vertices.slice(0)
              if (!vertices[1]) {
                this.startMultiSelection()
                return
              }

              // 返回选中的图像图形集合
              let selectedImageGraphics = this.filterSelectedStreamNodeImageGraphics(Point)
              console.log('框选选中元素数量：', selectedImageGraphics.length)
              if (this.boxSelectComplete) {
                this.boxSelectComplete(selectedImageGraphics)
              }
              // 停止多选
              this.stopMultiSelection()
              // 重新开始
              this.startMultiSelection()
            })
            this.view.focus()
          }
        )
        .catch(err => {
          console.log('startMultiSelection err: >>>>>> ', err)
        })
    },
    // 显示框选图形
    showRectangleGraphic(evt, Point, ScreenPoint, Graphic, Polygon) {
      let vertices = evt.vertices
      if (vertices.length < 2) { // 忽略坐标少于2个的集合
        return
      }

      // delete myltiSelection graphic
      let removedGraphics = this.view.graphics.filter(item => {
        return item.attributes.kind === 'multiSelection'
      })
      removedGraphics.forEach(item => {
        this.view.graphics.remove(item)
      })

      // 创建矩形图形
      let rectangle = this.createRectangle(vertices, Point, ScreenPoint, Polygon)
      // 添加到地图并显示
      this.addRectanleGraphic(1, 'multiSelection', rectangle, Graphic)
    },
    // 根据创建一个多边形
    createRectangle(vertices, Point, ScreenPoint, Polygon) {
      this.startSelectionMapPoint = new Point({
        x: vertices[0][0],
        y: vertices[0][1],
        spatialReference: this.view.spatialReference
      })

      this.stopSelectionMapPoint = new Point({
        x: vertices[1][0],
        y: vertices[1][1],
        spatialReference: this.view.spatialReference
      })
      // 转换为屏幕坐标
      this.startSelectionScreenPoint = this.view.toScreen(this.startSelectionMapPoint)
      this.stopSelectionScreenPoint = this.view.toScreen(this.stopSelectionMapPoint)

      let x = Math.round(
        Math.min(this.stopSelectionScreenPoint.x, this.startSelectionScreenPoint.x)
      )
      let y = Math.round(
        Math.min(this.stopSelectionScreenPoint.y, this.startSelectionScreenPoint.y)
      )
      let width = Math.abs(this.stopSelectionScreenPoint.x - this.startSelectionScreenPoint.x)
      let height = Math.abs(this.stopSelectionScreenPoint.y - this.startSelectionScreenPoint.y)

      let ldScreenPoint = new ScreenPoint({ // 左下点屏幕坐标
        x: x,
        y: y + height
      })
      let urScreenPoint = new ScreenPoint({ // 右上点屏幕坐标
        x: x + width,
        y: y
      })
      // 转换为地图坐标
      let lowerLeftMapPoint = this.view.toMap(ldScreenPoint)
      let upperRightMapPoint = this.view.toMap(urScreenPoint)

      return new Polygon({
        rings: [
          [lowerLeftMapPoint.x, upperRightMapPoint.y],
          [upperRightMapPoint.x, upperRightMapPoint.y],
          [upperRightMapPoint.x, lowerLeftMapPoint.y],
          [lowerLeftMapPoint.x, lowerLeftMapPoint.y]
        ],
        spatialReference: this.view.spatialReference
      })
    },
    // 过滤选中的视频节点图像图形
    filterSelectedStreamNodeImageGraphics(Point) {
      let selectedGraphics = []
      this.view.graphics.items.forEach(item => {
        if (item.attributes.kind === 'streamNode' && item.attributes.data) {
          let streamNode = item.attributes.data
          if (streamNode.longitude && streamNode.latitude) {
            let streamNodeMapPoint = new Point({
              longitude: streamNode.longitude,
              latitude: streamNode.latitude,
              spatialReference: this.view.spatialReference})
            let streamNodeScreenPoint = this.view.toScreen(streamNodeMapPoint)

            if (streamNodeScreenPoint.x >= this.startSelectionScreenPoint.x &&
              streamNodeScreenPoint.y >= this.startSelectionScreenPoint.y &&
              streamNodeScreenPoint.x <= this.stopSelectionScreenPoint.x &&
              streamNodeScreenPoint.y <= this.stopSelectionScreenPoint.y) {
              selectedGraphics.push(item)
            }
          }
        }
      })
      return selectedGraphics
    },
    stopMultiSelection() {
      let removedGraphics = this.view.graphics.filter(item => {
        return item.attributes.kind === 'multiSelection'
      })
      removedGraphics.forEach(item => {
        this.view.graphics.remove(item)
      })
    },
    // 返回当前经纬度坐标
    getCurrentCoordinate() {
      let p = {}
      if (this.ccWidget) {
        p = this.ccWidget.currentLocation
        console.log('longitude: ', p.longitude, '  latitude: ', p.latitude)
      }
      return p
    },
    // 根据标注方式，返回当前标记图标
    getMarkerIcon(marker) {
      if (this.classificationMethod === '1') {
        return '/static/img/map/streamnode/' + marker.icon
      } else if (this.classificationMethod === '2') {
        return '/static/img/map/streamnode/' + marker.iconByRegion
      } else if (this.classificationMethod === '3') {
        return '/static/img/map/streamnode/' + marker.iconByRegionKind
      }
      return ''
    },
    handleCommand(command) {
      console.log('>>>>', command)
      // 测距
      if (command === 'distanceMeasure') {
        this.toggleDistanceMeasure()
      }
      // 鹰眼
      if (command === 'overviewMap') {
        this.toggleOverviewMap()
      }
      // 取点
      if (command === 'coordinateConversion') {
        this.coordinateConversionVisible = !this.coordinateConversionVisible
        if (this.coordinateConversionVisible) {
          return this.view.ui.add(this.ccWidget, 'top-right')
        }
        return this.view.ui.remove(this.ccWidget)
      }
      // 比例尺
      if (command === 'scaleBar') {
        this.toggleScaleBar()
      }
    },
    // 标注
    handleRadio(val) {
      let graphics = this.view.graphics.clone()
      graphics.items.forEach(item => {
        item.symbol.url = this.getMarkerIcon(item.attributes.data)
      })

      this.view.graphics.removeAll()
      graphics.items.forEach(item => {
        this.view.graphics.add(item)
      })
    },
    // 框选
    handleBoxRadio(val) {
      if (val === '1') { // 单选
        if (this.draw) this.draw.reset()
      }
      if (val === '2') { // 多选
        this.startMultiSelection()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/arcgisMap/ArcgisMap.js